
interface ProgressBarProps {
  current: number;
  total: number;
  percentage: number;
  isCharger?: boolean;
  decimals?: number;
}

export function ProgressBar({ current, total, percentage, isCharger = false, decimals = 0 }: ProgressBarProps) {
  if (current === 0 && total === 0) return null;

  const fmt = (v: number) => decimals > 0 ? v.toFixed(decimals) : Math.round(v).toString();

  if (total === 0) {
    return <span className="text-xs text-gray-500">{fmt(current)}</span>;
  }

  const getBarColor = (pct: number) => {
    if (isCharger) return 'bg-green-500';
    if (pct <= 50) return 'bg-green-500';
    if (pct <= 90) return 'bg-yellow-500';
    return 'bg-red-500';
  };

  const getTextColor = (pct: number) => {
    if (isCharger) return 'text-green-700';
    if (pct <= 50) return 'text-green-700';
    if (pct <= 90) return 'text-yellow-700';
    return 'text-red-700';
  };

  const displayPercentage = Math.min(percentage, 100);

  return (
    <div className="flex flex-col gap-1 w-full">
      <div className="flex justify-between text-xs">
        <span className="text-gray-600">{fmt(current)} / {fmt(total)}</span>
        {percentage > 0 && (
          <span className={`font-medium ${getTextColor(percentage)}`}>
            {parseFloat(displayPercentage.toFixed(1))}%
          </span>
        )}
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        {percentage > 0 && (
          <div
            className={`h-2 rounded-full ${getBarColor(percentage)}`}
            style={{ width: `${displayPercentage}%` }}
          />
        )}
      </div>
    </div>
  );
}
